import { domain, adminSubDomain,partypoker_login_rurl } from '../common/config.js';
import { withRouter } from 'react-router-dom';
import { axiosCallService } from '../common/apiCallService';
import queryString from 'query-string';

const LoginRedirect = (props) => {
    const subdomain = window.location.hostname.split('.')[0];
    if (localStorage.getItem('token')) {
        if (subdomain === adminSubDomain) {
            props.history.push('/pokerwatch')
        } else {
            props.history.push(`/mygamelogin`)
            // if (JSON.parse(localStorage.getItem('userRole')).includes('PLAYER')) {
            //     let location = '/home',
            //         playerData = await axiosCallService(`/reportCard/getLast48HrsDtls`, {
            //             accountName: localStorage.getItem('accountName'), gameType: ['cash', 'tournament'],
            //             gameSubType: ['Texas Holdem'],
            //             ringType: ['6-seater', 'Full Ring']
            //         });
            //     if (playerData.data.isMygameLanding) {
            //         location = `/home?${queryString.stringify({
            //             gameType: playerData.data.gameType,
            //             dateRange: playerData.data.dateRange,
            //             ringType: playerData.data.ringType,
            //             gameSubType: playerData.data.gameSubType,
            //             totalHandPlayed: playerData.data.totalHandPlayed
            //         })}`
            //         props.history.push(location)
            //     } else if (!playerData.data.isMygameLanding) {
            //         if (playerData.data.singleReport) {
            //             location = `/ReportCard/${localStorage.getItem('accountName')}/${playerData.data.gameType}?${queryString.stringify({
            //                 hitLevel: 'All Level',
            //                 hitRange: playerData.data.dateRange,
            //                 hitType: playerData.data.ringType
            //             })}`
            //             props.history.push(location)
            //         } else {
            //             location = '/SkillLevel?logintype=player'
            //             props.history.push(location)
            //         }
            //     }
            // }
        }
    } else {
        if (subdomain === adminSubDomain) {
            props.history.push('/mygamelogin')
        } else {
            location.replace(partypoker_login_rurl, "_self", "toolbar=yes,scrollbars=yes,resizable=yes")
        }
    }
    return (null)
}

export default withRouter(LoginRedirect);


/** WEBPACK FOOTER **
 ** ./src/components/LoginRedirect.js
 **/